import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, CheckCircle2 } from 'lucide-react';
const problems = [{
  num: '01 / 04',
  title: 'El problema que nadie te dice',
  sin: 'Usás el inhalador de corticoide todos los días para que tu hijo respire, sin saber que ese mismo medicamento tiene un impacto acumulativo en sus huesos, su hígado y sus glándulas suprarrenales.',
  con: 'Tenés el protocolo completo de blindaje nutricional para proteger la densidad ósea, la función hepática y el sistema inmune del niño mientras recibe la medicación necesaria. Sin culpa. Con gestión.'
}, {
  num: '02 / 04',
  title: 'El problema de la candidiasis silenciosa',
  sin: 'Tu hijo tiene la lengua con capa blanca, voz ronca y se enferma de garganta frecuentemente. No lo conectás con el inhalador porque nadie te explicó que el corticoide depositado en la boca genera hongos.',
  con: 'Tenés el protocolo anti-candidiasis completo: desde el enjuague bucal post-inhalación (que reduce el riesgo en un 80%) hasta las soluciones naturales para restaurar la microbiota orofaríngea.'
}, {
  num: '03 / 04',
  title: 'El problema del potasio y el azúcar post-crisis',
  sin: 'Después de cada episodio con salbutamol tu hijo está irritable, inquieto, con hambre y no podés explicar por qué. No sabés que el broncodilatador altera su glucemia y su potasio en cada uso.',
  con: 'Tenés el protocolo completo de recuperación metabólica de las 72 horas post-crisis: qué darle de comer, cuándo, en qué cantidad y por qué. La bebida de recuperación post-salbutamol lista para preparar.'
}, {
  num: '04 / 04',
  title: 'El problema del crecimiento y los huesos',
  sin: 'Usás el corticoide inhalado por meses o años sin saber que tiene un efecto demostrado sobre la absorción de calcio y la velocidad de crecimiento del niño a dosis altas.',
  con: 'Tenés la guía de suplementación natural de calcio, potasio y zinc para compensar lo que la medicación le roba al cuerpo. Con alimentos de la verdulería del barrio, sin suplementos caros.'
}];
export const MasterKitExplanation = () => {
  return <section className="py-10 sm:py-14 md:py-20 bg-white" data-id="element-150">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-151">
        <div className="text-center mb-8 sm:mb-12 md:mb-16" data-id="element-152">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-heading font-bold text-gray-900 mb-3 sm:mb-4" data-id="element-153">
            ¿QUÉ AGREGA EL KIT BIO-LIMPIEZA BRONQUIAL™?
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-brand-orange font-medium" data-id="element-154">
            Para madres que quieren también proteger el cuerpo de su hijo de los
            efectos de la medicación
          </p>
        </div>

        <div className="space-y-4 sm:space-y-6 md:space-y-8" data-id="element-155">
          {problems.map((prob, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} whileHover={{
          y: -3,
          transition: {
            duration: 0.2
          }
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.35
        }} className="bg-cream-dark rounded-2xl p-4 sm:p-5 md:p-6 border border-brand-gold/20 shadow-sm cursor-default" data-id="element-156">
              <div className="flex flex-col md:flex-row md:items-center gap-3 sm:gap-4 mb-4 sm:mb-6" data-id="element-157">
                <span className="text-brand-gold font-heading font-bold text-lg sm:text-xl" data-id="element-158">
                  {prob.num}
                </span>
                <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900" data-id="element-159">
                  {prob.title}
                </h3>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-5 md:gap-6" data-id="element-160">
                <div className="bg-white p-4 sm:p-5 rounded-xl border border-red-100" data-id="element-161">
                  <div className="flex items-center gap-2 text-red-600 font-bold mb-2 sm:mb-3 text-sm sm:text-base" data-id="element-162">
                    <XCircle size={16} data-id="element-163" /> Sin Kit Bio-Limpieza
                  </div>
                  <p className="text-gray-600 text-xs sm:text-sm leading-relaxed" data-id="element-164">
                    {prob.sin}
                  </p>
                </div>

                <div className="bg-brand-green/5 p-4 sm:p-5 rounded-xl border border-brand-green/20" data-id="element-165">
                  <div className="flex items-center gap-2 text-brand-green font-bold mb-2 sm:mb-3 text-sm sm:text-base" data-id="element-166">
                    <CheckCircle2 size={16} data-id="element-167" /> Con Kit Bio-Limpieza
                  </div>
                  <p className="text-gray-800 text-xs sm:text-sm leading-relaxed font-medium" data-id="element-168">
                    {prob.con}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};